import { render, staticRenderFns } from "./TempTrendBl.vue?vue&type=template&id=15a94684&scoped=true&"
import script from "./TempTrendBl.vue?vue&type=script&lang=js&"
export * from "./TempTrendBl.vue?vue&type=script&lang=js&"
import style0 from "./TempTrendBl.vue?vue&type=style&index=0&id=15a94684&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15a94684",
  null
  
)

/* custom blocks */
import block0 from "./TempTrendBl.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports